import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import throttle from 'lodash/fp/throttle';
import get from 'lodash/fp/get';
import optimisticUpdates from './middleware/optimisticUpdates';
import requestUpdates from './middleware/requestUpdates';
import loadStateClear from './middleware/loadStateClear';
import reducer from './reducers';
import { loadState, saveState } from './localStorage';
import { useDispatch } from 'react-redux';
import { Middleware } from 'redux';

const middleware = [thunk, optimisticUpdates, requestUpdates, loadStateClear];

if (process.env.NODE_ENV !== 'production') {
  middleware.push(require('redux-immutable-state-invariant').default());
}

const persistedState = loadState();
const store = createStore(
  reducer,
  persistedState,
  applyMiddleware(...(middleware as Middleware<any, any, any>[])),
);

store.subscribe(
  throttle(1000, () => {
    const state = store.getState();
    const toPersist = {
      user: {
        settings: get('user.settings', state),
      },
    };

    saveState(toPersist);
  }),
);

type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;

export type RootState = ReturnType<typeof store.getState>;

export default store;
